<template>
	<ElButton :type="type" @click="$emit('buttonclick')" round :class="{ 'button--onlyicon': onlyIcon, 'button-submit': isSubmit }" :loading="loading">
		<template #loading>
			<LoadingIcon />
		</template>
		<slot />
	</ElButton>
</template>

<script lang="ts">
import LoadingIcon from '@/assets/icons/LoadingIcon.vue';

export default {
	name: 'TheButton',
	data() {
		return {};
	},
	emits: ['buttonclick'],
	components: {
		LoadingIcon,
	},
	props: {
		type: {
			type: String,
			default: 'primary',
		},
		onlyIcon: {
			type: Boolean,
			default: false,
		},
		isSubmit: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
